import createMuiTheme from './createMuiTheme';
var defaultTheme = createMuiTheme();
export default defaultTheme;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/styles/defaultTheme.js
// module id = 375
// module chunks = 121